import { BackendFiat, toFiat } from '@/common/secondary/token/BackendFiat';

export interface BackendExclusiveTaxDeduction {
  nonDeductibleAmount: BackendFiat;
}

export const toExclusiveTaxDeduction = (backendExclusiveTaxDeduction: BackendExclusiveTaxDeduction) => ({
  nonDeductibleAmount: toFiat(backendExclusiveTaxDeduction.nonDeductibleAmount),
});
